let language = {
    DETAIL_INTEGRATION_TITLE: "Product Integration",
    DETAIL_INTEGRATION_DESCRIBE: "Product integration is gathering the product information that matches your need and generating a specific product. The existing product integration is mainly for API products. In this stage, the API product must integrate through the relevant interface. Please refer to the related documents for the API integration.",
    DETAIL_DETAILS_NAME: "Details",
    DETAIL_INTEGRATION_TITLE_1: "Simple PC Ordering",
    DETAIL_INTEGRATION_DESCRIBE_1: "Simple PC Ordering is available after the API integration. Users can add the API product customization information (customized side, customized picture, etc.), address information, and SKU product ID in the Simple PC Ordering.",
    DETAIL_INTEGRATION_TITLE_2: "Product Customization Data",
    DETAIL_INTEGRATION_DESCRIBE_2: "Product Customization Data The user needs to provide the picture or design for all customized sides in Simple PC Ordering. The parameters of Simple PC Ordering included ‘side’, ‘materialPath’, ‘image’ etc. Image refers to the customized picture or design which needs to provide by the user;MaterialPath refers to a material configuration path which can be blank.",
    DETAIL_INTEGRATION_TITLE_3: "Simple PC Ordering Reference ",
    DETAIL_INTEGRATION_HEAD_1: "Variable",
    DETAIL_INTEGRATION_HEAD_2: "Type",
    DETAIL_INTEGRATION_HEAD_3: "Required",
    DETAIL_INTEGRATION_HEAD_4: "Description",
    DETAIL_INTEGRATION_body_1: "side",
    DETAIL_INTEGRATION_body_2: "string",
    DETAIL_INTEGRATION_body_3: "true",
    DETAIL_INTEGRATION_body_4: "Name of the customized product. The name must align with the specific customized side. ",
    DETAIL_INTEGRATION_body_5: "materialPath",
    DETAIL_INTEGRATION_body_6: "string",
    DETAIL_INTEGRATION_body_7: "false",
    DETAIL_INTEGRATION_body_8: "Product material address",
    DETAIL_INTEGRATION_body_9: "image",
    DETAIL_INTEGRATION_body_10: "string",
    DETAIL_INTEGRATION_body_11: "true",
    DETAIL_INTEGRATION_body_12: "Product customized picture. The picture must align with the customized area. (Provided by the User)",
    DETAIL_INTEGRATION_TITLE_4: "Customize Product Data",
    DETAIL_INTEGRATION_TITLE_5: "side",
    DETAIL_INTEGRATION_TITLE_6: "materialPath",
    DETAIL_IMAGE_TITLE: "For example:"
}
export { language }